import { Injectable } from '@angular/core';
import * as _ from 'lodash';

interface PieDataParameters {
  value: number;
  label: string;
}

@Injectable({
  providedIn: 'root',
})
export class SheetsService {
  constructor() {}

  getPieData(data: PieDataParameters[], options?: any) {
    let total = 0;
    let series: any[] = _.map(data, d => {
      return { name: d.label, y: Math.round(d.value) };
    });
    total = _(data).map('value').sum();
    return {
      colors: ['#B91C1C', '#0D9E5D', '#F5A800'],
      chart: {
        margin: 0,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        backgroundColor: 'transparent',
        spacingTop: 0,
        spacingBottom: 0,
        type: 'pie',
      },
      credits: {
        enabled: false,
      },
      title: {
        text: null,
        align: 'center',
        verticalAlign: 'middle',
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          center: ['50%', '50%'],
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          innerSize: '65%',
          data: series,
        },
      ],
      ...options,
    };
  }

  getInOutData(simulation) {
    let inout: any = {};
    inout.outputs = {};
    inout.outputs.credit = simulation.result.monthlyCredit;
    inout.outputs.gestion =
      (simulation.result.rent *
        simulation.parameters.managementFeesPercentage) /
      100;
    inout.outputs.copro =
      (simulation.result.rent *
        simulation.parameters.coOwnershipFeesPercentage) /
      100;
    const estateTax =
      simulation.parameters.estateTax !== null &&
      simulation.parameters.estateTax !== undefined
        ? simulation.parameters.estateTax
        : simulation.parameters.estateTaxPercentage;
    inout.outputs.fonciere = (simulation.result.rent * estateTax) / 1200;
    inout.outputs.impot = simulation.result.tax;
    inout.outputs.total = _.reduce(inout.outputs, _.add);

    inout.inputs = {};
    inout.inputs.rent = simulation.result.rent;
    inout.inputs.reduction = simulation.result.reduction;
    inout.inputs.total = _.reduce(inout.inputs, _.add);
    return inout;
  }

  simulationsTooltip = {
    investedAmount:
      "Il s'agit du montant total, en euros, investit dans le projet.",
    partRevalorisationRate: 'Réévaluation de la valeur du bien.',
    rentalReversionRate: 'Réévaluation du montant de la location.',
    loanDuration:
      "La durée de vie d'un emprunt équivaut au temps qui reste avant que le prêt n'arrive à échéance. Elle débute au moment où le prêt est émis et s'achève à la date finale établie pour le remboursement.",
    loanRate:
      "Le taux du crédit indique le pourcentage d'intérêt à rembourser à l'organisme prêteur vous ayant octtroyé la somme dont vous avez besoin.",
    loanInsuranceRate:
      "Le taux de l'assurance est une protection exigée par l'organisme prêteur, dans le cas où l'assuré serait dans l'incapacité de poursuivre le remboursement de l'emprunt. Le taux d'assurance définit la cotisation annuelle de l'emprunteur. ",
  };
}
